import { render, staticRenderFns } from "./CollectionNavigationItems.vue?vue&type=template&id=7c6c4997&scoped=true&"
import script from "./CollectionNavigationItems.vue?vue&type=script&lang=js&"
export * from "./CollectionNavigationItems.vue?vue&type=script&lang=js&"
import style0 from "./CollectionNavigationItems.vue?vue&type=style&index=0&id=7c6c4997&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c6c4997",
  null
  
)

export default component.exports